// Pure helpers for the RecordCard "Ordered · Delivered · Remaining" view (sale + purchase lines).
// mode: 'full' (ordered/done/remaining), 'ordered' (quote / planned / uncommitted: ordered only),
// 'cancelled' (what was done before cancellation, no remaining).
const n = (v) => (v == null || v === '' || Number.isNaN(Number(v)) ? null : Number(v));
export const fmtQty = (v) => (n(v) == null ? '—' : n(v).toLocaleString(undefined, { maximumFractionDigits: 2 }));

export function deliveryMode(status, txStatus) {
  if (status === 'cancelled' || txStatus === 'cancelled') return 'cancelled';
  if (['quote', 'uncommitted', 'planned'].includes(status) || txStatus === 'planned') return 'ordered';
  return 'full';
}

// l: a line carrying qty_ordered|qty, qty_delivered|qty_received, qty_remaining. Returns null if no ordered qty.
export function lineDelivery(l, mode) {
  const ordered = n(l.qty_ordered) ?? n(l.qty);
  if (ordered == null) return null;
  if (mode === 'ordered') return { mode, ordered };
  const target = n(l.qty) ?? ordered;   // current qty: below the original order when a line was closed short
  const done = n(l.qty_delivered) ?? n(l.qty_received) ?? 0;
  const remaining = Math.max(0, n(l.qty_remaining) ?? target - done);
  const pct = target > 0 ? Math.min(100, Math.round((done / target) * 100)) : 0;
  return { mode, ordered, target, short: ordered - target > 0.005, done, remaining, pct, complete: mode === 'full' && remaining <= 0.005 && done > 0, partial: done > 0.005 && remaining > 0.005 };
}

// One-line header summary; sums only when every line shares a unit. Returns null if not summable.
export function deliverySummary(lines, mode, label, w = {}) {   // w = { of, remaining }: localized words (default English)
  if (mode === 'ordered' || !lines.length) return null;
  const units = new Set(lines.map(l => l.unit || ''));
  if (units.size > 1) return null;
  const ds = lines.map(l => l.d).filter(Boolean);
  if (ds.length !== lines.length) return null;
  const ordered = ds.reduce((s, d) => s + d.target, 0), done = ds.reduce((s, d) => s + d.done, 0);
  const u = lines[0].unit ? ' ' + lines[0].unit : '';
  const pct = ordered > 0 ? Math.round((done / ordered) * 100) : 0;
  const head = `${label} ${fmtQty(done)} ${w.of || 'of'} ${fmtQty(ordered)}${u} (${pct} %)`;
  return mode === 'cancelled' ? head : `${head} · Remaining ${fmtQty(ds.reduce((s, d) => s + d.remaining, 0))}${u}`;
}
